import { Box, Flex, Text, useColorModeValue, VStack } from '@chakra-ui/react';
import QRCode from 'qrcode.react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import useIsLandScapeMachine from '@/hook/useIsLandScapeMachine';
import useLongMachineSetting from '@/hook/useLongMachineSetting';

const QRCodeCreate = ({ url, onClose }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`machine.${key}`);
  const i18n_backend_response = (key) => t(`backend_response.${key}`);

  const bgColor = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.800', 'white');

  // 確保有 URL，如果沒有就使用預設值
  const qrUrl = url || `${process.env.REACT_APP_API_URL}/create-machine`;

  const isLandscapeMachine = useIsLandScapeMachine();
  const { longMachineVideoHeight } = useLongMachineSetting();

  return (
    <Flex
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      bg="rgba(0, 0, 0, 1)"
      backdropFilter="blur(2px)"
      zIndex="9999"
      justifyContent="center"
      alignItems="center"
      pt={isLandscapeMachine ? longMachineVideoHeight : '0px'} // 如果是橫屏機台，則加上影片高度的 padding top
    >
      <VStack
        bg={bgColor}
        p="6"
        borderRadius="lg"
        spacing="4"
        align="center"
        shadow="xl"
        position={'relative'}
      >
        {/* <IconButton
          icon={<IoClose size={32} />}
          position="absolute"
          right="-50px"
          top="-50px"
          colorScheme="gray"
          rounded="full"
          onClick={onClose}
          size="lg"
          aria-label="Close"
        /> */}
        <Text
          fontSize="xl"
          fontWeight="bold"
          color={textColor}
          textAlign="center"
          mb="4"
        >
          {i18n('scanQRCode')}
        </Text>
        <Box p="4" bg="white" borderRadius="md">
          <QRCode
            value={qrUrl}
            size={200}
            level="H"
            renderAs="svg" // 用SVG渲染獲得更好的清晰度
          />
        </Box>
      </VStack>
    </Flex>
  );
};

export default QRCodeCreate;
